import { ENDPOINT_BASE } from '@/config/endpoints'

export const ENDPOINT_NOTIFICATIONS = `${ENDPOINT_BASE}/e`
export const ENDPOINT_PUSH_TOKENS = `${ENDPOINT_BASE}/users/push-tokens`
